import epsClient from '../../../api/enrollment-platform-client/api-client'
import { OperatorPerformanceResponse } from '../types/PerformanceDashboard'

export interface GetOperatorPerformanceParams {
  effectiveDate: string
  timezone?: string
}

export async function getOperatorPerformance(
  params: GetOperatorPerformanceParams
): Promise<OperatorPerformanceResponse> {
  const response = await epsClient.get<OperatorPerformanceResponse>(
    '/benefits/operator-performance',
    {
      params,
    }
  )
  return response.data
}
